import { apiCommand } from "./index.jsx"

export const getLotById = id => async ( dispatch, getState ) => {
  const result = await apiCommand( dispatch, getState, "getLotById", { id } )

  if ( result.message === "OK" ) {
    dispatch( {
      type: "ADD_LOT",
      lot: result.result,
    } )
  }

  return result
}



// WEBPACK FOOTER //
// ./src/actions/lots.jsx